export default {
  'securityEvents.title': 'SIEM (Security Information and Event Management)',
  'securityEvents.column.scope': 'Scope',
  'securityEvents.column.categories': 'Categories',
  'securityEvents.column.destinations': 'Destinations',
  'securityEvents.column.readyDestinations': 'Ready and active destinations',
  'securityEvents.column.effective': 'Effective',
  'securityEvents.column.connector': 'Connector',
  'securityEvents.categories.all': 'All events',
  'securityEventCategory.authentication': 'Authentication classification',
  'securityEventCategory.admin': 'Administration',
  'securityEventCategory.auth': 'Authentication',
  'securityEventCategory.environment': 'Environment',
  'securityEventCategory.process': 'Process',
  'securityEventCategory.role': 'Roles',
  'securityEventCategory.user': 'Users',
  'securityEventScopeCategory.global': 'Company',
  'securityEventScopeCategory.scoped': 'Scoped',
  'securityEventScopeType.environment': 'Environment',
  'siemConnectorType.genericHttps': 'Generic HTTPS',
  'siemConnectorType.splunkHec': 'Splunk HEC',
  'siemConnectorType.eventHub': 'Azure Event Hub',
  'siemDestinationStatus.incomplete': 'Incomplete',
  'siemDestinationStatus.ready': 'Ready',
  'siemDestinationAuthorizationType.noAuth': 'No Auth',
  'siemDestinationAuthorizationType.apiKeyInHeader': 'API Key In Header',
  'siemDestinationAuthorizationType.apiKeyInQueryParameters': 'API Key In Query Parameters',
  'siemDestinationAuthorizationType.bearerToken': 'Bearer Token',
  'siemDestinationAuthorizationType.basicAuth': 'Basic Auth',
  'securityEvents.delivery.effective': 'Effective',
  'securityEvents.delivery.missingDestination': 'No effective destination',
  'securityEvents.delivery.inactive': 'Inactive',
  'securityEvents.action.destinations': 'Destinations',
  'securityEvents.action.test': 'Test connection',
  'securityEvents.field.url': 'URL',
  'securityEvents.field.keyName': 'API key name',
  'securityEvents.field.keyValue': 'API key value',
  'securityEvents.field.endpoint': 'HEC endpoint',
  'securityEvents.field.hecToken': 'HEC token',
  'securityEvents.field.index': 'Index',
  'securityEvents.field.source': 'Source',
  'securityEvents.field.sourceType': 'Source type',
  'securityEvents.field.connectionString': 'Connection string',
  'securityEvents.field.eventHubName': 'Event Hub name',
  'securityEvents.secret.stored': 'Stored',
  'securityEvents.validation.https': 'The address must use HTTPS',
  'securityEvents.validation.eventHubName':
    'Use the Azure hub name: letters, numbers, dot, hyphen, or underscore.',
  'securityEvents.destination.needsTest':
    'This destination is incomplete. Save and test the connection before it can deliver events.',
  'securityEvents.destination.retest':
    'The configuration changed. Test the connection again before this destination can be Ready.',
  'securityEvents.destinations.title': 'Destinations',
  'securityEvents.destinations.description': 'Destinations for {name}',
  'securityEvents.delete.subscription':
    'This deletes the subscription and all of its destinations. This cannot be undone.',
  'securityEvents.action.operational': 'Operational status',
  'securityEvents.operational.title': 'Operational status',
  'securityEvents.operational.description': 'Observed activity for {name}',
  'securityEvents.operational.observed': 'Observed activity — last 24 hours',
  'securityEvents.operational.window': '{start} – {end}',
  'securityEvents.operational.projectionStarted': 'Projection since {date}',
  'securityEvents.operational.partial': 'Partial view of observed activity',
  'securityEvents.operational.truncated':
    '{included} of {total} destinations included; counters are for the destinations shown',
  'securityEvents.operational.notInitialized':
    'There is no operational coverage for this window yet',
  'securityEvents.operational.unavailable': 'Observed activity could not be read',
  'securityEvents.operational.noDestinations': 'No destinations configured',
  'securityEvents.operational.operation': 'Operation',
  'securityEvents.operational.lastActivity': 'Last activity',
  'securityEvents.operational.lastSuccess': 'Last success',
  'securityEvents.operational.lastFailure': 'Last failure',
  'securityEvents.operational.lastAttempt': 'Last attempt',
  'securityEvents.operational.attempts': 'Attempts',
  'securityEvents.operational.recentLimit': 'Recent rows',
  'securityEvents.operational.viewDestination': 'View activity',
  'securityEvents.operational.safeError': 'Safe code',
  'securityEvents.operational.httpStatus': 'HTTP',
  'securityEvents.operational.noRecentActivityHint': 'No recent operational activity was observed',
  'securityEvents.operational.awaitingDeliveryHint': 'Observed activity without a confirmed result',
  'siemDeliveryStatus.pending': 'Pending',
  'siemDeliveryStatus.sending': 'Sending / pending processing',
  'siemDeliveryStatus.delivered': 'Delivered',
  'siemDeliveryStatus.failed': 'Failed',
  'siemDeliveryStatus.deadLetter': 'Dead letter',
  'siemDerivedOperationalStatus.disabled': 'Disabled',
  'siemDerivedOperationalStatus.incomplete': 'Incomplete',
  'siemDerivedOperationalStatus.noRecentActivity': 'No observed activity',
  'siemDerivedOperationalStatus.failing': 'Failing',
  'siemDerivedOperationalStatus.degraded': 'Degraded',
  'siemDerivedOperationalStatus.operational': 'Operational',
  'siemDerivedOperationalStatus.awaitingDelivery': 'Awaiting delivery',
  'securityEvents.error.timeout': 'Timed out',
  'securityEvents.error.network': 'Network error',
  'securityEvents.error.redirect-blocked': 'Redirect blocked',
  'securityEvents.error.invalid-configuration': 'Invalid configuration',
  'securityEvents.error.company-mismatch': 'Company does not match',
  'securityEvents.error.unsupported-connector': 'Unsupported connector',
  'securityEvents.error.destination-missing': 'Destination not found',
  'securityEvents.error.destination-inactive': 'Destination inactive',
  'securityEvents.error.destination-not-ready': 'Destination is not Ready',
  'securityEvents.error.blob-unreadable': 'Content could not be read',
  'securityEvents.error.unauthorized': 'Unauthorized',
  'securityEvents.error.resource-not-found': 'Resource not found',
  'securityEvents.error.message-too-large': 'Message too large',
  'securityEvents.error.service-busy': 'Service busy',
  'securityEvents.error.invalid-response': 'Invalid response',
  'securityEvents.error.splunk-hec-rejected': 'Splunk HEC rejected the delivery',
  'securityEvents.error.splunk-ack-unsupported': 'Splunk does not support acknowledgement',
  'securityEvents.error.http': 'HTTP {status}',
  'securityEvents.error.unknown': 'Failure observed; safe detail is not available',
};
